import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiTwitter, FiMessageCircle, FiSend, FiUsers, FiTrendingUp, FiHeart } = FiIcons;

const Community = () => {
  const socialLinks = [
    {
      name: 'Twitter',
      icon: FiTwitter,
      followers: '50K+',
      description: 'Latest updates and memes',
      color: 'from-blue-400 to-blue-600',
      href: '#'
    },
    {
      name: 'Discord',
      icon: FiMessageCircle,
      followers: '25K+',
      description: 'Chat with the community',
      color: 'from-purple-400 to-purple-600',
      href: '#'
    },
    {
      name: 'Telegram',
      icon: FiSend,
      followers: '30K+',
      description: 'Real-time discussions',
      color: 'from-blue-500 to-cyan-500',
      href: '#'
    }
  ];

  const communityStats = [
    { label: 'Total Members', value: '100K+', icon: FiUsers },
    { label: 'Daily Active', value: '25K+', icon: FiTrendingUp },
    { label: 'Engagement Rate', value: '85%', icon: FiHeart }
  ];

  return (
    <section id="community" className="py-20 px-4 bg-gradient-to-br from-pink-50 to-purple-50">
      <div className="container mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Join the <span className="bg-gradient-to-r from-pink-600 to-purple-600 bg-clip-text text-transparent">PinkZilla Army</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Be part of the strongest, most supportive crypto community. Together, we're building something extraordinary.
          </p>
        </motion.div>

        {/* Community Stats */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16">
          {communityStats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="bg-white rounded-2xl p-8 text-center shadow-lg"
            >
              <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-purple-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <SafeIcon icon={stat.icon} className="text-white text-2xl" />
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">{stat.value}</div>
              <div className="text-gray-600">{stat.label}</div>
            </motion.div>
          ))}
        </div>

        {/* Social Links */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {socialLinks.map((social, index) => (
            <motion.a
              key={index}
              href={social.href}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all block"
            >
              <div className={`w-16 h-16 bg-gradient-to-r ${social.color} rounded-full flex items-center justify-center mb-6`}>
                <SafeIcon icon={social.icon} className="text-white text-2xl" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-2">{social.name}</h3>
              <div className="text-lg font-semibold text-pink-600 mb-2">{social.followers}</div>
              <p className="text-gray-600">{social.description}</p>
            </motion.a>
          ))}
        </div>

        {/* Community Highlights */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="bg-white rounded-3xl p-8 shadow-2xl"
        >
          <h3 className="text-2xl font-bold text-gray-800 mb-8 text-center">What Our Community Says</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-4xl mb-4">🚀</div>
              <p className="text-gray-600 italic">"PinkZilla is going to the moon! Best community ever!"</p>
              <p className="text-sm text-gray-500 mt-2">- @CryptoKing</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">💎</div>
              <p className="text-gray-600 italic">"Diamond hands all the way! This is just the beginning."</p>
              <p className="text-sm text-gray-500 mt-2">- @DiamondHodler</p>
            </div>
            <div className="text-center">
              <div className="text-4xl mb-4">🔥</div>
              <p className="text-gray-600 italic">"The energy in this community is incredible! LFG!"</p>
              <p className="text-sm text-gray-500 mt-2">- @MemeQueen</p>
            </div>
          </div>
        </motion.div>

        {/* Join CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-16 text-center"
        >
          <div className="bg-gradient-to-r from-pink-500 to-purple-600 rounded-3xl p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-4">Ready to Join the Revolution?</h3>
            <p className="text-lg mb-6 opacity-90">
              Don't just watch from the sidelines - be part of the PinkZilla movement!
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <motion.a
                href="https://pump.fun/AV1AQPodLxw43q7qB7c8HXHx6NrMSGi9z3tb4U7ypump"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="bg-white text-pink-600 px-8 py-3 rounded-full font-bold text-lg inline-flex items-center justify-center space-x-2 hover:bg-pink-50 transition-all"
              >
                <SafeIcon icon={FiTrendingUp} />
                <span>Buy $PINKZILLA</span>
              </motion.a>
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="border-2 border-white text-white px-8 py-3 rounded-full font-bold text-lg hover:bg-white hover:text-pink-600 transition-all inline-flex items-center justify-center space-x-2"
              >
                <SafeIcon icon={FiUsers} />
                <span>Join Community</span>
              </motion.button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Community;